import { FormProvider, UseFormReturn } from 'react-hook-form'
import { cn } from 'src/shared/components/ui/utils'

export const FormWrapper = ({
  onSubmit,
  methods,
  children,
  className,
}: {
  onSubmit: (values: any) => void
  methods: UseFormReturn<any>
  children: React.ReactNode
  className?: string
}) => {
  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(onSubmit)}
        className={cn('space-y-3', className)}
      >
        {children}
      </form>
    </FormProvider>
  )
}
